import { removeCookie, setCookie } from '/src/common/cookie-utils';

export const updateLanguages = (state, languages) => {
  state.availableLanguages = languages;
};

export const updateSelectedEntity = (state, entityId) => {
  state.entity.selected = entityId;
};

export const setAppLoadingFlag = (state, value) => {
  state.hasRouteLoaded = value;
};

export const setFilterPane = (state, value) => {
  state.showFilterPane = value;
};

export const setMenuItemsList = (state, { items, remember, url }) => {
  state.menuItems = items || [];
  if (remember) {
    if (url) {
      // Store url with which menu is associated (E.g Dashboard url)
      setCookie('currentMenuItems', url);
    } else {
      removeCookie('currentMenuItems');
    }
  }
};

export const setDelegateCount = (state, count) => {
  state.delegateCount = count;
};

export const setForceLogout = (state, forceLogout) => {
  state.forceLogout = forceLogout;
};

export const setTasksPage = (state, value) => {
  state.isTasksPage = value;
};

export const setMiniDrawerFlag = (state, value) => {
  state.miniDrawer = value;
  setCookie('minimise', value + '');
};

export const setDashboardDesignURL = (state, value) => {
  state.dashboardDesignURL = value;
};

export const setEntityData = (state, { list, flattenList, selected }) => {
  state.entity.list = list;
  state.entityList = list;
  state.entity.flattenList = flattenList;
  state.entity.selected = selected;
};

export const setNewDownloadsCount = (state, value) => {
  state.newDownloadsCount = value;
};

export const updatePreviousState = (state, statePath) => {
  state.previousState = statePath;
};

export const setHeadTitleTemplate = (state, value) => {
  state.headTitleTemplate = value;
};

export const setPlatformTheme = (state, value = null) => {
  state.platformTheme = value;
};

export const setIsQuicklink = (state, isQuicklink) => {
  state.isQuicklink = isQuicklink;
};

export const setToasts = (state, toasts) => {
  state.toasts = toasts;
};

export const setUploadProgress = (state, { id, value }) => {
  state.progress[id] = value;
};

export const removeUploadProgress = (state, id) => {
  delete state.progress[id];
};
